<template>
    <!-- Single post: one full-width feature. -->
    <mosaic-card v-if="posts.length === 1" :post="posts[0]" featured class="max-w-3xl" />

    <!-- Two posts: a balanced pair of features. -->
    <div v-else-if="posts.length === 2" class="grid grid-cols-1 gap-6 md:grid-cols-2">
        <mosaic-card v-for="post in posts" :key="post.id" :post="post" featured />
    </div>

    <!-- Three or more: a featured hero occupying a 2x2 block with the rest
         flowing as compact cells. Never a single tall column. -->
    <div v-else class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        <mosaic-card :post="hero" featured class="sm:col-span-2 lg:row-span-2" />
        <mosaic-card v-for="post in rest" :key="post.id" :post="post" />
    </div>
</template>

<script lang="ts" setup>
import { Post } from '@/types';
import { computed } from 'vue';
import MosaicCard from './MosaicCard.vue';

const props = defineProps<{
    posts: Post[];
}>();

// For the 3+ layout: first post is the hero, the rest fill the grid.
const hero = computed<Post>(() => props.posts[0]);
const rest = computed<Post[]>(() => props.posts.slice(1));
</script>
